'use client';

import FadeIn from '../ui/FadeIn';
import { ShieldCheck, Zap, Lock, Database, Users } from 'lucide-react';
import { useTranslations } from '@/lib/i18n/TranslationProvider';

export default function TrustStrip() {
    const { t } = useTranslations();
    const icons = [ShieldCheck, Zap, Lock, Database, Users];
    const colors = [
        "hover:text-[var(--color-md-primary)]",
        "hover:text-amber-600",
        "hover:text-blue-600",
        "hover:text-purple-600",
        "hover:text-[var(--color-md-primary)]"
    ];
    return (
        <section className="section-padding-tight bg-[var(--color-md-surface)] border-b border-[var(--color-md-outline)] relative overflow-hidden">
            <div className="container mx-auto px-6 relative z-10">
                <FadeIn className="text-center mb-14">
                    <p className="text-sm font-semibold text-[var(--color-md-primary)] mb-2">{t.trustStrip.why}</p>
                    <h2 className="text-2xl md:text-3xl font-black text-[var(--color-md-on-surface)] tracking-tight">
                        {t.trustStrip.tagline}
                    </h2>
                </FadeIn>
                <div className="flex flex-wrap items-center justify-center gap-12 md:gap-24">
                    {t.trustStrip.items.map((name, i) => {
                        const Icon = icons[i];
                        const m3Class = i % 3 === 0 ? 'm3-icon-tonal' : i % 3 === 1 ? 'm3-icon-tertiary' : 'm3-icon-secondary';
                        return (
                            <FadeIn key={i} delay={i * 0.1} direction="up" yOffset={20}>
                                <div className="group flex items-center gap-3 transition-all duration-300 cursor-default">
                                    <div className={`w-11 h-11 ${m3Class} flex-shrink-0`}>
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <span className="text-sm font-semibold text-[var(--color-md-on-surface-variant)] group-hover:text-[var(--color-md-on-surface)] transition-colors">
                                        {name}
                                    </span>
                                </div>
                            </FadeIn>
                        );
                    })}
                </div>
            </div>
            <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--color-md-surface)] to-transparent z-20 pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--color-md-surface)] to-transparent z-20 pointer-events-none" />
        </section>
    );
}
